<template>
  <div class="zoox-component zoox-input-list">
    <template v-for="(item, index) of items">
      <div :key="index" class="input-item-container">
        <slot name="item" :item="item" :index="index"> </slot>
        <z-icon class="remove-icon" @click="onRemove({item, index})"
          >$remove_circle_outline_rounded</z-icon
        >
      </div>
    </template>
  </div>
</template>

<script>
/**
 * @displayName Input List
 */
export default {
  name: 'ZInputList',
  props: {
    items: {
      type: Array,
    },
  },
  methods: {
    onRemove(item) {
      this.$emit('remove', item)
    },
  },
}
</script>

<style lang="scss" scoped>
.input-item-container {
  display: flex;
  align-items: center;

  .remove-icon {
    margin-left: 8px;
    margin-bottom: 24px;
  }
}
</style>
